var _excluded = ["count", "maxCount", "alignCount", "hideCount", "xOffset", "yOffset", "Icon"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useRef, useLayoutEffect, useState } from 'react';
import { StyledContainer, StyledCount } from './IconWithCount.styles';

/**
 * Renders a `react-icons` icon with a count badge to the left or right
 */
export var IconWithCount = _ref => {
  var {
      count,
      maxCount,
      alignCount,
      hideCount,
      xOffset,
      yOffset,
      Icon
    } = _ref,
    iconProps = _objectWithoutProperties(_ref, _excluded);
  var iconRef = useRef(null);
  var [iconDimensions, setIconDimensions] = useState();
  useLayoutEffect(() => {
    if (iconRef) {
      var _iconRef$current, _iconRef$current$getC;
      var rect = iconRef === null || iconRef === void 0 ? void 0 : (_iconRef$current = iconRef.current) === null || _iconRef$current === void 0 ? void 0 : (_iconRef$current$getC = _iconRef$current.getClientRects()) === null || _iconRef$current$getC === void 0 ? void 0 : _iconRef$current$getC[0];
      if (rect) {
        setIconDimensions(rect);
      }
    }
  }, []);
  var max = maxCount || 99;
  var countToDisplay = count <= max ? count : "+".concat(maxCount);
  return /*#__PURE__*/React.createElement(StyledContainer, null, /*#__PURE__*/React.createElement("span", {
    ref: iconRef
  }, /*#__PURE__*/React.createElement(Icon, iconProps)), !hideCount ? /*#__PURE__*/React.createElement(StyledCount, {
    "data-testid": "count",
    count: count,
    maxCount: max,
    alignment: alignCount || 'right',
    rect: iconDimensions,
    xOffset: xOffset,
    yOffset: yOffset
  }, countToDisplay) : null);
};
IconWithCount.defaultProps = {
  maxCount: 99,
  alignCount: 'right',
  xOffset: 0,
  yOffset: 0,
  size: '40px'
};